import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { closeCampaignAndGroupSelector } from '../../actions/campaignAndGroupSelector';
import {
    changeLocation,
    changeLocationHard,
    closeSidebarMenus,
    processSidebarClick,
    toggleSidebarExpand
} from '../../actions/common';
import { Sidebar, SidebarProps } from '../../components/Sidebar/Sidebar';
import { SidebarLinksMenuLink } from '../../components/Sidebar/SidebarLinksMenu/SidebarLinksMenu';
import {
    selectSecondLevelSidebarLinks,
    selectSelectedSidebarItemIdByRoute,
    selectSidebarItems,
    selectSidebarItemsIds
} from '../../selectors/sidebar/sidebar';
import { UrlHelpers } from '../../service/UrlHelpers';
import {
    SecondLevelSidebarMenuIds,
    SidebarDynamicItemsIds,
    SidebarItemsIds,
    SidebarStaticItemsIds,
    ThirdLevelSidebarMenuIds
} from '../../typings/sidebar';
import { State } from '../../typings/state';

export interface StateProps {
    login: string;
    items: SidebarItemsIds;
    expanded?: boolean;
    selectedItemId?: SidebarStaticItemsIds | SidebarDynamicItemsIds;
    secondLevelMenuId?: SecondLevelSidebarMenuIds;
    thirdLevelMenuId?: ThirdLevelSidebarMenuIds;
    secondLevelLinks?: SidebarLinksMenuLink[];
    isCampaignAndGroupSelectorOpen: boolean;
}

export interface DispatchProps {
    processSidebarClick: (
        id: SidebarStaticItemsIds | SidebarDynamicItemsIds
    ) => void;
    onExpandClick: () => void;
    goToCampaigns: (ulogin: string) => void;
    goToRecommendations: (ulogin: string) => void;
    goToTools: (ulogin: string) => void;
    onParanjaClick: () => void;
    goToShowClients: () => void;
    closeCampaignAndGroupSelectorHandler: () => void;
}

type MergedProps = SidebarProps;

const mapStateToProps = (state: State): StateProps => {
    const { login } = state.commonData;
    const {
        expanded,
        secondLevelMenuId,
        thirdLevelMenuId,
        selectedItemId
    } = state.commonData.sidebar;

    const {
        campaignAndGroupSelector: { isCampaignAndGroupSelectorOpen }
    } = state.grid;

    const items = selectSidebarItemsIds(state);

    const secondLevelLinks = selectSecondLevelSidebarLinks(
        state,
        secondLevelMenuId || SecondLevelSidebarMenuIds.default
    );

    let selectedId = selectedItemId;
    if (selectedId === undefined) {
        selectedId = selectSelectedSidebarItemIdByRoute(state);
    }

    return {
        expanded,
        items,
        selectedItemId: selectedId,
        secondLevelMenuId,
        thirdLevelMenuId,
        secondLevelLinks,
        login,
        isCampaignAndGroupSelectorOpen
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        processSidebarClick(
            id: SidebarStaticItemsIds | SidebarDynamicItemsIds
        ) {
            dispatch(processSidebarClick(id));
        },

        onExpandClick() {
            dispatch(toggleSidebarExpand());
        },

        goToCampaigns(ulogin: string) {
            dispatch(
                changeLocation(
                    UrlHelpers.getCampaignListUrl(),
                    { ulogin },
                    false
                )
            );
        },

        goToShowClients() {
            dispatch(
                changeLocationHard(UrlHelpers.getDirectLink('showClients'))
            );
        },

        goToRecommendations(ulogin: string) {
            dispatch(
                changeLocation(
                    UrlHelpers.getRecommendationsBaseUrl(),
                    { ulogin },
                    false
                )
            );
        },

        goToTools(ulogin: string) {
            dispatch(
                changeLocation(
                    UrlHelpers.getToolsUrl(),
                    {
                        ulogin
                    },
                    false
                )
            );
        },

        onParanjaClick() {
            dispatch(closeSidebarMenus());
        },

        closeCampaignAndGroupSelectorHandler() {
            dispatch(closeCampaignAndGroupSelector());
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps
): MergedProps => {
    const {
        expanded,
        secondLevelMenuId,
        thirdLevelMenuId,
        secondLevelLinks,
        isCampaignAndGroupSelectorOpen
    } = stateProps;
    const {
        onExpandClick,
        onParanjaClick,
        closeCampaignAndGroupSelectorHandler
    } = dispatchProps;

    return {
        expanded: Boolean(expanded),
        onExpandClick,
        onParanjaClick,
        secondLevelMenuId,
        secondLevelLinks,
        thirdLevelMenuId,
        items: selectSidebarItems(stateProps, dispatchProps),
        isCampaignAndGroupSelectorOpen,
        closeCampaignAndGroupSelectorHandler
    };
};

export const SidebarContainer = connect<
    StateProps,
    DispatchProps,
    {},
    MergedProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Sidebar);
